<template>
    <div :class="getItemClass()" @click="onSelect" @dblclick="onDoubleClick" :drag-value="info.id">
        <div v-show="!edit" class="group-item-info">
            <div class="group-item-info__name">
              <tooltip-content :content="info.groupName" placement="top-start">
                <span >{{info.groupName}}</span>
              </tooltip-content>
            </div>
            <span :class="{
              'group-item-info__num': true,
              'group-item-info__num--drag': dragging
            }">{{info.groupMemberList && info.groupMemberList.length}}</span>
            <div v-show="!dragging" class="group-item-handle">
              <yxt-tooltip  
                class="item" 
                effect="dark" 
                :content=" $t('pc_biz_group_rename') /* 重命名 */ " 
                placement="top"
                :open-delay="2000"
                :hide-delay="0"
              >
                <span class="group-item-handle__icon">
                  <i class="yxt-icon-edit" @click.stop="onEdit"></i>
                </span>
              </yxt-tooltip>
              <yxt-tooltip 
                class="item" 
                effect="dark" 
                :content=" $t('pc_biz_group_delete') /* 删除 */" 
                placement="top"
                :open-delay="2000"
                :hide-delay="0"
              >
                <span class="group-item-handle__icon">
                  <i class="yxt-icon-delete" @click.stop="deleteGroup(info.id)"></i>
                </span>
              </yxt-tooltip>
            </div>
        </div>
        <div @click.stop v-show="edit"  class="group-item-info group-item-info--edit">
            <yxt-input 
              ref="nameRef"
              size="small"
              v-model="currentName"
              maxlength="20"
              show-word-limit 
              @blur="saveGroupName"
              @keyup.enter.native="saveGroupName"
            ></yxt-input>
        </div>
    </div>
</template>

<script>
import { Input, Popover } from 'yxt-pc';
import { onOutsideClick, clearOutSideClick } from '../../../services/outSideClick';
import TooltipContent from './tooltip-content.vue';

export default {
  components: {
    'yxt-input': Input,
    'yxt-popover': Popover,
    'tooltip-content': TooltipContent
  },
  props: {
    info: {
      type: Object,
      require: true
    },
    mode: {
      type: String,
      require: 'default'
    },
    id: {
      type: String,
      require: ''
    },
    dragging: {
      type: Boolean,
      default: false
    }
  },
  inject: {
    setGroupId: {
      default: ()=>{}
    },
    deleteGroup: {
      default: ()=>{}
    }
  },
  data() {
    return {
      edit: false,
      currentName: '',
      time: 200,
      timeOut: null
    };
  },
  mounted() {
    this.info.edit && this.onEdit();
    this.mode === 'default' && onOutsideClick(this.$el, this.clickOutside, false);
  },
  beforeDestroy() {
    this.mode === 'default' && clearOutSideClick(this.$el);
  },
  methods: {
    getItemClass() {
      return {
        'group-item': true,
        'group-item-default': this.mode === 'default',
        'group-item-select': this.mode === 'select',
        'group-item-select--active': this.info.id === this.id
      };
    },
    onDoubleClick() {
      // 消除单击事件
      if (this.timeOut) {
        clearTimeout(this.timeOut);
        this.timeOut = null;
      }
      this.onEdit();
    },
    onEdit() {
      if (this.mode === 'select') {
        return;
      }
      if (this.edit) {
        return;
      }

      this.currentName = this.info.groupName;
      this.edit = true;
      this.$nextTick(()=>{
        this.$refs.popoverRef && this.$refs.popoverRef.showPopper && this.$refs.popoverRef.doToggle();
        if (this.$refs.nameRef) {
          setTimeout(() => {
            this.$refs.nameRef.focus();
            this.$refs.nameRef.select();
          });
        }
      });
    },
    saveGroupName() {
      if (this.edit) {
        this.edit = false;
        this.info.edit = false;
        this.currentName.trim() && (this.info.groupName = this.currentName);
      }
    },
    clickOutside() {
      this.saveGroupName();
    },
    onSelect() {
      if (this.edit || this.timeOut) {
        return;
      }
      this.timeOut = setTimeout(() => {
        clearTimeout(this.timeOut);
        this.timeOut = null;
        this.mode === 'select' ? this.$emit('select', this.info.id) : this.setGroupId(this.info.id);
      }, this.time);
    }
  }
};
</script>
<style lang="scss">
.group-item-popover{
    padding: 0;
    width: 82px;
    padding: 8px 0;
    span{
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #595959;
        font-size: 14px;
        cursor: pointer;

        &:hover{
            background: #F0F6FF;
        }
    }
}
</style>
<style lang="scss" scoped>
.group-item{
    height: 38px;
    display: flex;
    align-items: center;
    padding: 0 0 0 12px;
    border-radius: 4px;

    &:hover{
        background: #F5F5F5;
    }
    &-info{
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        &__name{
            font-size: 14px;
            color: #595959;
            line-height: 20px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: calc(100% - 46px);
        }

        &__num{
            font-size: 12px;
            font-weight: 400;
            color: #595959;
            line-height: 20px;
            user-select: none;
            -ms-user-select: none;
            margin-right: 12px;

            // &--edit{
            //   margin-right: 0px;
            // }
        }
        &__num--drag{
          display: initial !important;
        }
        /deep/ .yxt-input{
          // .yxt-input__inner{
          //     height: 100%;
          // }
        }
    }
    &-info--edit{
      margin-left: -12px;
      padding: 2px 3px;
    }
    &-handle{
        cursor: pointer;
        display: none;
        flex-grow: 1;
        > i {
          font-size: 10px;
        }
    }
}
.group-item-default{
    &:hover{
        .group-item-handle{
            display: flex;
            margin-right: 8px;
            align-items: center;
            justify-content: space-between;
            transform: translateX(5px);
        }
        .group-item-handle__icon{
          width: 24px;
          height: 24px;
          border-radius: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #595959;
          &:hover{
            background: #E9E9E9;
          }
        }
        .group-item-handle__icon+.group-item-handle__icon{
          margin-left: 8px;
        }
        .group-item-info__name{
            color: #262626;
            font-size: 14px;
            font-weight: 500;
        }
        .group-item-info__num{
            display: none;
        }
    }
}
.group-item-select{
  margin-top: 2px;
}
.group-item-select--active{
  background: #F0F6FF !important;
  .group-item-info__name{
    color: #436BFF !important;
    font-weight: 500;
  }
}
</style>>
